import { refreshContent } from "./refreshContent";
import { updateURL } from "./updateURL";
let type;
export function getReadingViewType() {
    return type;
}
export function setReadingViewType(newType = "week", options) {
    if (type === newType) {
        return type;
    }
    const ignoreRefresh = options === null || options === void 0 ? void 0 : options.ignoreRefresh;
    type = newType;
    window.localStorage.setItem("type", type); // set to localStorage
    if (!ignoreRefresh) {
        refreshContent();
        updateURL();
    }
    return type;
}
